export default {
  beforeMount: function() {
    this.$vfPages.setMetaFor(this.$route.path);
  },
};
